<template>
  <component :is="summaryLink ? 'a' : 'div'"
             :href="summaryLink || undefined"
             class="open-or-close-summary">
    <div>

      <template v-if="todayDisplay &&
                      !todayDisplay.isClosed &&
                      !isPastClosingTime(todayDisplay.closes)">
        <div class="open-or-close-summary__day">
          {{ openingMessage }} {{ formatTimeAmPm(todayDisplay.closes) }}
        </div>
      </template>

      <template v-else>
        <div class="open-or-close-summary__day">

          <span v-if="todayDisplay?.label"
                class="open-or-close-summary__label">
            {{ `${todayDisplay.label},` }}
          </span>

          {{ closedMessage }}

          <span v-if="nextOpenDisplay?.opens"
                class="open-or-close-summary__hours">
            {{ formatTimeAmPm(nextOpenDisplay.opens) }}
          </span>

        </div>
      </template>

    </div>
  </component>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import {
    useOpeningHours,
    formatTimeAmPm,
    formatClosingMessage,
    isPastClosingTime,
    todayDayDisplayName,
    type OpeningHoursItem,
    type OpeningHoursOverride,
  } from '../../modules/utils/useOpeningHours';

  interface Props {
    openingMessage?: string;
    closingMessage?: string;
    summaryLink?: string;
    openingHours?: OpeningHoursItem[];
    openingHoursOverride?: OpeningHoursOverride[];
  }

  const props = withDefaults(defineProps<Props>(), {
    openingMessage: '',
    closingMessage: '',
    summaryLink: '',
    openingHours: () => [],
    openingHoursOverride: () => [],
  });

  const { todayDisplay, nextOpenDisplay } = useOpeningHours(
    () => props.openingHours,
    () => props.openingHoursOverride,
  );

  const closedMessage = computed(() =>
    formatClosingMessage(todayDisplay.value?.message || props.closingMessage, nextOpenDisplay.value)
  );
</script>
